import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StepperContext, StepperHeaderStep, useStepper } from '@applyonline/shared/components';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
const StepperBase = ({ children, submitLabel }) => {
    const { t } = useTranslation('shared');
    const { current, steps, currentStep, currentPosition, onSubmit, isSubmitting, setNext, setPrevious } = useStepper();
    const hasPrevious = Boolean(setPrevious);
    const hasNext = Boolean(setNext);
    const handleSubmit = () => {
        if (onSubmit)
            onSubmit();
    };
    return (_jsxs("div", { children: [_jsx("div", { children: _jsx("ul", { className: "stepper__header", children: steps.map(({ step, ...stepProps }, index) => (_jsx(StepperHeaderStep, { ...stepProps, position: index + 1, selected: step === current }, step))) }) }), _jsx("section", { className: "stepper__content", children: children }), !currentStep?.hideControl && (_jsxs("footer", { className: "stepper__footer", children: [_jsx("div", { className: "stepper__action_wrapper", children: hasPrevious && (_jsxs("button", { type: "button", className: "btn btn-grey", onClick: setPrevious, children: [_jsx("i", { className: "fa-light fa-arrow-left" }), _jsx("span", { children: t('common.back') })] })) }), _jsx("div", { className: "stepper__count", children: _jsxs("span", { children: [currentPosition, "\u00A0/\u00A0", steps.length] }) }), _jsxs("div", { className: "stepper__action_wrapper", children: [hasNext && (_jsxs("button", { type: "button", className: "btn btn-blue btn-simple", disabled: currentStep?.invalid || currentStep?.loading, onClick: setNext, children: [_jsx("span", { children: t('common.next') }), _jsx("i", { className: "fa-regular fa-arrow-right" })] })), !hasNext && (_jsx("button", { type: "button", className: "btn btn-blue btn-simple", disabled: currentStep?.invalid || currentStep?.loading || isSubmitting, onClick: handleSubmit, children: submitLabel || t('common.submit') }))] })] }))] }));
};
const Stepper = ({ children, current, setCurrentStep, onSubmit, isSubmitting = false, submitLabel, }) => {
    const [steps, setSteps] = useState([]);
    const setStep = (options) => {
        setSteps((state) => {
            const step = state.find((s) => s.step === options.step);
            if (step) {
                Object.assign(step, options);
                return [...state];
            }
            return [...state, options];
        });
    };
    const { currentStep, currentPosition, currentIndex } = useMemo(() => {
        const stepIndex = steps.findIndex((s) => s.step === current);
        const stepFound = stepIndex !== -1;
        return {
            currentStep: stepFound ? steps[stepIndex] : undefined,
            currentIndex: stepFound ? stepIndex : undefined,
            currentPosition: stepFound ? stepIndex + 1 : undefined,
        };
    }, [current, steps]);
    const { setNext, setPrevious } = useMemo(() => {
        let pSetNext;
        let pSetPrevious;
        if (currentIndex !== undefined) {
            for (let i = currentIndex + 1; i < steps.length; i += 1) {
                if (!steps[i].disabled) {
                    pSetNext = () => setCurrentStep(steps[i].step);
                    break;
                }
            }
            for (let i = currentIndex - 1; i >= 0; i -= 1) {
                if (!steps[i].disabled) {
                    pSetPrevious = () => setCurrentStep(steps[i].step);
                    break;
                }
            }
        }
        return { setNext: pSetNext, setPrevious: pSetPrevious };
    }, [currentIndex, setCurrentStep, steps]);
    useEffect(() => {
        if (currentStep?.disabled && setNext)
            setNext();
    }, [currentStep?.disabled, setNext]);
    const ctxValue = useMemo(() => ({
        current,
        setCurrentStep,
        setStep,
        setNext,
        setPrevious,
        steps,
        onSubmit,
        isSubmitting,
        currentStep,
        currentPosition,
    }), [current, setCurrentStep, setNext, setPrevious, steps, onSubmit, isSubmitting, currentStep, currentPosition]);
    return (_jsx(StepperContext.Provider, { value: ctxValue, children: _jsx(StepperBase, { submitLabel: submitLabel, children: children }) }));
};
export default Stepper;
